import { clients, ProjectState } from '@moovly/clients';
import { Membership, GroupUserRole } from '@moovly/clients/lib/resources/group/group.interfaces';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../config/store';
import { toastInfo, toastWarning } from '../utils/ui';
import {
  DefaultApiRequestState,
  getDefaultApiRequestState,
  getDefaultReducerForAsyncRequest,
  RequestType,
} from './default';
import { t } from '@moovly/i18n';
import {
  BasicProjectInfo,
  Project,
  ProjectsResponse,
} from '@moovly/clients/lib/resources/projects/projects.interfaces';

export const updateProject = createAsyncThunk<
  Project,
  { groupId: string, projectId: string }
>('projects/update', ({ groupId, projectId }) => {
  return clients.Projects.changeWorkspace(projectId, groupId);
});

type ProjectsState = {
  projects: DefaultApiRequestState<
    ProjectsResponse,
    [RequestType.Get, RequestType.Post, RequestType.Put, RequestType.Delete]
  >;
};

const initialState: ProjectsState = {
  projects: getDefaultApiRequestState([RequestType.Get, RequestType.Post, RequestType.Put, RequestType.Delete]),
};


export const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    reset: () => initialState,
    resetAddRequest: (state: ProjectsState) => {
      state.projects.request.post.status = RequestStatus.Unsent;
    },
  },
  extraReducers: {
    ...getDefaultReducerForAsyncRequest({
      thunk: updateProject,
      requestType: RequestType.Put,
      getInitialState: (state) => state.projects,
    }),
  },
});

export default projectsSlice;
